"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NjordsWarcryAbilityHandler = exports.NjordsWarcryActorAbilityFactory = exports.NjordsWarcryAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const CameraAction_1 = require("../../core/vfx/CameraAction");
const core_2 = require("../../core/effects/core");
class NjordsWarcryAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.NjordsWarcry;
        this.__typeName = "NjordsWarcry";
    }
}
exports.NjordsWarcryAbilityArgs = NjordsWarcryAbilityArgs;
let NjordsWarcryActorAbilityFactory = class NjordsWarcryActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("NjordsWarcry", "AllAllies", 4);
    }
};
NjordsWarcryActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("NjordsWarcry")
], NjordsWarcryActorAbilityFactory);
exports.NjordsWarcryActorAbilityFactory = NjordsWarcryActorAbilityFactory;
let NjordsWarcryAbilityHandler = class NjordsWarcryAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                const level = container.getLevel(ability.invokerId);
                const power = container.getAttributeScore(ability.invokerId, AttributeType_1.AttributeType.Power);
                const buffSequence = sequence
                    .pushSequence("sequential")
                    .push(core_1.CameraVfxStepArgs.Effect(new CameraAction_1.EffectVfxCameraAction("shake"), 800))
                    .pushSequence("parallel");
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(allyId => {
                    container.applyBuff({
                        sequence: buffSequence.pushSequence("sequential"),
                        creatorId: ability.invokerId,
                        targetId: allyId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new core_2.LinkedEffectsEffectArgs([
                            new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Power, container.getPercentOfBaseAttributeScore(allyId, 10, "Power")),
                            new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.CriticalStrikeChance, 10)
                        ], false),
                        onApplied(sequence) {
                            sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "feet", "behind"), "FireMagicCircle"));
                        }
                    });
                });
            }
        });
    }
};
NjordsWarcryAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.NjordsWarcry)
], NjordsWarcryAbilityHandler);
exports.NjordsWarcryAbilityHandler = NjordsWarcryAbilityHandler;
